// extracted by mini-css-extract-plugin
export default {"tourTooltip":"GlobalNavAppsIconTooltip_tourTooltip__pdHbq","dismissButton":"GlobalNavAppsIconTooltip_dismissButton__fh+H+"};